const { REACT_APP_API_BASE_URL, REACT_APP_STAGE, REACT_APP_VERSION } =
  process.env;

const config = {
  baseUrl: `${REACT_APP_API_BASE_URL}${
    REACT_APP_STAGE === "staging" ? `/${REACT_APP_STAGE}` : ""
  }/v${REACT_APP_VERSION}`,
};

export default config;